import { DialogDismiss } from '@ariakit/react';
import cn from 'classnames';
import React from 'react';
import ClosePopupIcon from '../assets/images/ClosePopup.svg';
import * as styles from './styles.module.css';

export function DialogCloseButton({ className }: { className?: string }) {
  return (
    <DialogDismiss className={cn(styles.closeButtonContainer, className)}>
      <div className={styles.closeButton}>
        <img className={styles.icon} src={ClosePopupIcon} alt="Закрыть" />
      </div>
    </DialogDismiss>
  );
}
